import request from "../request"
import qs from "qs";

/**
 * 给用户发送验证码
 * @param {String} tel 手机号码
 * @returns 
 */
export function getCode(tel) {
  return request.get({
    url: "/security-auth/send-register-sms",
    params: {
      tel
    }
  })
}

/**
 * 验证用户输入的验证码和手机号是否匹对
 * @param {String} tel 手机号
 * @param {String} smsCode 验证码
 * @returns 
 */
export function verifyCode(tel, smsCode) {
  return request.post({
    url: "/security-auth/check-smscode",
    data: qs.stringify({
      tel,
      smsCode
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}

/**
 * 用户注册
 * @param {String} tel 手机号
 * @param {String} smsCode 验证码
 * @param {String} password 密码
 * @returns 
 */
export function register(tel, smsCode, password) {
  return request.post({
    url: "/security-auth/register",
    data: qs.stringify({
      tel,
      smsCode,
      password
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}

/**
 * 获取图形验证码
 * @returns 图片url
 */
export function getImgCode() {
  return request.get({
    url: "/security-auth/getVerifyCodeImg",
    responseType: "blob",
    showLoading: true
  })
}

/**
 * 用户登录
 * @param {String} username 用户名
 * @param {String} password 用户密码
 * @param {String} verifyCode 图形验证码
 * @returns 
 */
export function login(username, password, verifyCode) {
  return request.post({
    url: "/security-auth/login",
    data: qs.stringify({
      username,
      password,
      verifyCode
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}

/**
 * 退出登录
 * @returns 
 */
export function logout() {
  return request.get({
    url: "/security-auth/logout",
  })
}

/**
 * 获取当前登录的用户信息
 * @returns 
 */
export function getUserInfo() {
  return request.get({
    url: "/security-auth/admin-user"
  })
}

/**
 * 获取权限列表
 * @returns 
 */
export function getPermissionList() {
  return request.get({
    url: "/security/api/permission/list"
  })
}

